import { METHOD_API, createConnector, prefixApi } from "./Connector";

export const getSystemByPK = (PK: string) => {
  return createConnector(
    METHOD_API.GET,
    `${prefixApi}/system/${encodeURIComponent(PK)}`,
    null,
  );
};
